export const LE_WITH_DIFF_EMPID_SSN = ["CORROC:FO","CORROC:FED"]